import { useSWRConfig } from 'swr';
import { WORKFLOW_EXECUTION_BASE_URL } from './helpers';

export function useInvalidateWorkflowExecution() {
  const { mutate } = useSWRConfig();

  return (workflowExecutionId: string) => {
    mutate(`${WORKFLOW_EXECUTION_BASE_URL}/${workflowExecutionId}`);
  };
}
